

export class PaymentRequiredError extends Error {
    constructor(m: string) {
        super(m);
        Object.setPrototypeOf(this, PaymentRequiredError.prototype);
    }
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/exception/payment-required.error.ts